import { Box } from '@mui/material'
import BlockUserActionButton from './BlockUserActionButton'
import { IUser } from 'types/models/User'
import DeleteVerificationCodeActionButton from './DeleteVerificationCodeActionButton';

interface Props {
  verificationCodeId: string;
  refetch?: () => void;
}

export default function VerificationCodeActionButtons({ refetch, verificationCodeId }: Props) {
  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <DeleteVerificationCodeActionButton refetch={refetch} verificationCodeId={verificationCodeId} />
    </Box>
  )
}
